
import React from "react";
import "./Spinner.css";

/**
 * Component that is called when a page is loading.
 */
const Spinner = () => {
  return <div className="loader">Loading...</div>;
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/Components/Theme/Spinner/index.js